import React from 'react'

import { Modal } from '../../../components/Modal/Modal'
import { Container, Row } from 'react-bootstrap'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId, selectAuthenticatedUser } from '../../../store/auth/authSlice'
import './NotificationRequestModal.scss'
import { Button } from '../../../components/Button/Button'
import { useGetMeQuery } from '../../../store/user/user'

export type NotifyRequestModalProps = {
  show: boolean
  onSave: () => void
  onHide: () => void
}

export const NotificationRequestModal: React.FC<NotifyRequestModalProps> = ({ show, onSave, onHide }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId: accountId })
  const body = currentUser ? (
    <Container className='text-center'>
      <Row>
        <i className='bi bi-check-circle zocks-text-success notification-success-icon'></i>
      </Row>
      <Row>
        <h4 className='zocks-text-gray-900'>Thank you for your interest!</h4>
      </Row>
      <Row>
        <div>We will inform you at {currentUser.email} as soon as the feature becomes available.</div>
      </Row>
    </Container>
  ) : (
    <></>
  )

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<></>}
      body={body}
      footer={
        <div className='d-flex gap-3'>
          <Button variant='primary' onClick={onSave}>
            OK
          </Button>
        </div>
      }
      onFooterPrimaryAction={onSave}
      centered={true}
    />
  )
}
